// extracted by mini-css-extract-plugin
export default {"errorMessage":"errorMessage__ByLSp","closeIcon":"closeIcon__ftZ6g","largeErrorMessage":"largeErrorMessage__rjncW","textError":"textError__jxtxQ","helpingText":"helpingText__H3EQN","suggestionsList":"suggestionsList__HGmAj","login":"login__A6040","passwordForgotten":"passwordForgotten__mzBiz"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"errorMessage\":\"errorMessage__ByLSp\",\"closeIcon\":\"closeIcon__ftZ6g\",\"largeErrorMessage\":\"largeErrorMessage__rjncW\",\"textError\":\"textError__jxtxQ\",\"helpingText\":\"helpingText__H3EQN\",\"suggestionsList\":\"suggestionsList__HGmAj\",\"login\":\"login__A6040\",\"passwordForgotten\":\"passwordForgotten__mzBiz\"}";
        // 1787130558118
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  